export function folderFilterIsValid(filter: string): boolean {
  if (filter == '') return true

  if (filter && !filter.startsWith('/')) return false

  return true
}
